export const sortByAttributeAndOrder = (attr, sortOrder) => (a, b) => {
  const valA = a[attr];
  const valB = b[attr];

  const diff = (valA > valB) ? 1 : -1;

  return diff * sortOrder;
};

const sortData = (data, options) => {
  const { sortByAttribute, sortableAttributes } = options;

  if (!Array.isArray(data) || !sortByAttribute || !sortableAttributes) {
    return;
  }

  const selectedAttribute = sortableAttributes[sortByAttribute];

  const sortOrder = selectedAttribute.order === 'desc' ? -1 : 1;
  data.sort(sortByAttributeAndOrder(selectedAttribute.itemAttribute, sortOrder));

  data.forEach(d => sortData(d.values, options));
};

export default sortData;
